<irembogov-crvs-id-input
  [formControl]="formControl"
  [id]="field.key"
  [placeholder]="field.props['placeholder']"
  [regExp]="regExp"
  [statusClass]="statusClass"
  [documentTypeValue]="documentTypeValue"
  (dataFetch)="onDataFetch($event)"></irembogov-crvs-id-input>
